import React from 'react';
import { Html } from '@react-three/drei';

function Loader() {
  return (
    <Html>
      <div className='loader flex flex-col items-center justify-center w-48'> {/* Adjust width as needed */}
        <div className='w-20 h-20 ...'></div>
        <p className='mt-4 text-sm text-gray-500 tracking-wide'>Loading model, please wait...</p>
    </div>

    </Html>
  );
}

export default Loader;
